import { defineStore, acceptHMRUpdate } from 'pinia';
import useUsersStore from '@/stores/users';

const store = defineStore('integrations-microsoft', {
  state: () => ({
    outlook: {
      loading: null,
      connected: null,
      config: { sync_milestones: null, sync_tasks: null },
      elements: null,
      url: null,
      last_refresh: null,
    },
  }),

  getters: {
    getElementStatus: state => (el) => {
      const { outlook } = state;
      if (! outlook.connected) return null;
      const planning = el.getPlanning();
      if (! planning) return null;
      const elementConfig = outlook.elements.find(item => item.element_id == el.id && item.planning_id == planning.id);
      if (elementConfig && elementConfig.sync) {
        return elementConfig.sync == 1;
      }
      const usersStore = useUsersStore();
      if (! el.getUsers() || ! el.getUsers().find(item => item.id == usersStore.user.id)) return false;

      return outlook.config[el.isType('task') ? 'sync_tasks' : 'sync_milestones'] || false;
    },
  },

  actions: {
    refreshConnection() {
      const { outlook } = this;
      if (outlook.connected && moment().diff(outlook.last_refresh, 'minutes') < 2) return Promise.resolve(outlook);
      outlook.loading = true;
      return window.apiSrv.call('integrations/microsoft', undefined, undefined, true).then((response) => {
        outlook.connected = response?.data?.connected || false;
        _.extend(outlook.config, response?.data?.config || {});
        outlook.elements = response?.data?.elements || [];
        outlook.url = response?.data?.url || '';
        outlook.last_refresh = moment();
        return outlook;
      }).catch((message) => {
        outlook.connected = false;
        return Promise.reject(message);
      }).finally(() => {
        outlook.loading = false;
      });
    },

    setElementStatus({ el, sync }) {
      const { outlook } = this;
      const planning = el.getPlanning();
      if (! planning) return Promise.reject(new Error("missing planning"));
      outlook.loading = true;
      return window.apiSrv.call('integrations/microsoft/elements', 'store', { planning_id: planning.id, element_id: el.id, sync }).then((response) => {
        const elementConfigIndex = outlook.elements.findIndex(item => item.element_id == el.id && item.planning_id == planning.id);
        if (elementConfigIndex > -1) outlook.elements.splice(elementConfigIndex, 1);
        if (response?.data?.element) outlook.elements.push(response.data.element);
      }).finally(() => {
        outlook.loading = false;
      });
    },

    setConfig(data) {
      const { outlook } = this;
      outlook.loading = true;
      return window.apiSrv.call('integrations/microsoft/config', 'store', data).then((response) => {
        if (response?.data?.config) outlook.config = response.data.config;
      }).finally(() => {
        outlook.loading = false;
      });
    },

    postEvent({ el, elId }) { // passing original elId for dashboard els
      const planning = el.getPlanning();
      const element = { ...el.getAll(), id: elId || el.id };
      return window.apiSrv.call('integrations/microsoft/events', 'store', { element, planning: { id: planning.id, title: planning.getTitle(), url: planning.getUrl() } });
    },

    logout() {
      const { outlook } = this;
      outlook.loading = true;
      return window.apiSrv.call('integrations/microsoft/logout').then(() => {
        outlook.connected = false;
      }).finally(() => {
        outlook.loading = false;
      });
    },
  },
});

if (import.meta.hot) import.meta.hot.accept(acceptHMRUpdate(store, import.meta.hot));
export default store;
